/**
 * What an audit record calls its files (owner ruling 2026-10-25, round 5:
 * every persona saw server-made names like "m_comments-0f774749.jpg"):
 * "<question> — photo 1", numbered per kind in upload order. The stored file
 * name stays the SharePoint name; this is display only. No imports: the
 * server's audit PDF names files the same way (api/src/auditPdfModel.ts).
 */
const MAX_BASE = 40;

export function shortLabel(text: string, max = MAX_BASE): string {
  const t = text.replace(/\s+/g, ' ').trim();
  return t.length <= max ? t : `${t.slice(0, max - 1).trimEnd()}…`;
}

export function attachmentLabels(
  attachments: readonly { id: number; kind: string }[],
  base: string,
): Map<number, string> {
  const counts = new Map<string, number>();
  const out = new Map<number, string>();
  const prefix = shortLabel(base);
  for (const a of [...attachments].sort((x, y) => x.id - y.id)) {
    const kind = a.kind === 'pdf' ? 'PDF' : 'photo';
    const n = (counts.get(kind) ?? 0) + 1;
    counts.set(kind, n);
    out.set(a.id, prefix ? `${prefix} — ${kind} ${n}` : `${kind[0]!.toUpperCase()}${kind.slice(1)} ${n}`);
  }
  return out;
}
